import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import {
  CALLABLES,
  type CommissionUploadSourceInput,
  type CommissionUploadSourceResponse,
  type CommissionPullFromSalesforceInput,
  type CommissionPullFromSalesforceResponse,
  type CommissionComputeReportInput,
  type CommissionComputeReportResponse,
  type CommissionGetReportInput,
  type CommissionGetReportResponse,
  type CommissionSavePaidInput,
  type CommissionSavePaidResponse,
  type CommissionMyStatementInput,
  type CommissionMyStatementResponse,
  type CommissionStatementPdfInput,
  type CommissionStatementPdfResponse,
  type CommissionFxRefreshResponse,
  type CommissionConfirmPayoutInput,
  type CommissionConfirmPayoutResponse,
  type CommissionReleaseStatementsInput,
  type CommissionReleaseStatementsResponse,
  type CommissionMyReleasesInput,
  type CommissionMyReleasesResponse,
  type CommissionMyReleaseUrlInput,
  type CommissionMyReleaseUrlResponse,
  type CommissionMyTeamInput,
  type CommissionMyTeamResponse,
  type CommissionTeamReleaseUrlInput,
  type CommissionAccrualGetInput,
  type CommissionAccrualGetResponse,
  type CommissionAccrualExtendInput,
  type CommissionAccrualExtendResponse,
  type CommissionAccrualPreviewInput,
  type CommissionAccrualPreviewResponse,
  type CommissionPayoutPreviewInput,
  type CommissionPayoutPreviewResponse,
  type CommissionSendAccrualInput,
  type CommissionSendAccrualResponse,
  type CommissionAccrualSendUrlInput,
  type CommissionAccrualSendUrlResponse,
} from '@daaily/shared';

export const callCommissionUploadSource = httpsCallable<
  CommissionUploadSourceInput,
  CommissionUploadSourceResponse
>(functions, CALLABLES.COMMISSION_UPLOAD_SOURCE);

export const callCommissionPullFromSalesforce = httpsCallable<
  CommissionPullFromSalesforceInput,
  CommissionPullFromSalesforceResponse
>(functions, CALLABLES.COMMISSION_PULL_FROM_SALESFORCE);

export const callCommissionComputeReport = httpsCallable<
  CommissionComputeReportInput,
  CommissionComputeReportResponse
>(functions, CALLABLES.COMMISSION_COMPUTE_REPORT);

export const callCommissionGetReport = httpsCallable<
  CommissionGetReportInput,
  CommissionGetReportResponse
>(functions, CALLABLES.COMMISSION_GET_REPORT);

export const callCommissionSavePaid = httpsCallable<
  CommissionSavePaidInput,
  CommissionSavePaidResponse
>(functions, CALLABLES.COMMISSION_SAVE_PAID);

export const callCommissionMyStatement = httpsCallable<
  CommissionMyStatementInput,
  CommissionMyStatementResponse
>(functions, CALLABLES.COMMISSION_MY_STATEMENT);

export const callCommissionStatementPdf = httpsCallable<
  CommissionStatementPdfInput,
  CommissionStatementPdfResponse
>(functions, CALLABLES.COMMISSION_STATEMENT_PDF);

export const callCommissionFxRefresh = httpsCallable<
  Record<string, never>,
  CommissionFxRefreshResponse
>(functions, CALLABLES.COMMISSION_FX_REFRESH);

export const callCommissionConfirmPayout = httpsCallable<
  CommissionConfirmPayoutInput,
  CommissionConfirmPayoutResponse
>(functions, CALLABLES.COMMISSION_CONFIRM_PAYOUT);

export const callCommissionReleaseStatements = httpsCallable<
  CommissionReleaseStatementsInput,
  CommissionReleaseStatementsResponse
>(functions, CALLABLES.COMMISSION_RELEASE_STATEMENTS);

export const callCommissionMyReleases = httpsCallable<
  CommissionMyReleasesInput,
  CommissionMyReleasesResponse
>(functions, CALLABLES.COMMISSION_MY_RELEASES);

export const callCommissionMyReleaseUrl = httpsCallable<
  CommissionMyReleaseUrlInput,
  CommissionMyReleaseUrlResponse
>(functions, CALLABLES.COMMISSION_MY_RELEASE_URL);

export const callCommissionMyTeam = httpsCallable<
  CommissionMyTeamInput,
  CommissionMyTeamResponse
>(functions, CALLABLES.COMMISSION_MY_TEAM);

export const callCommissionTeamReleaseUrl = httpsCallable<
  CommissionTeamReleaseUrlInput,
  CommissionMyReleaseUrlResponse
>(functions, CALLABLES.COMMISSION_TEAM_RELEASE_URL);

export const callCommissionAccrualGet = httpsCallable<
  CommissionAccrualGetInput,
  CommissionAccrualGetResponse
>(functions, CALLABLES.COMMISSION_ACCRUAL_GET);

export const callCommissionAccrualPreview = httpsCallable<
  CommissionAccrualPreviewInput,
  CommissionAccrualPreviewResponse
>(functions, CALLABLES.COMMISSION_ACCRUAL_PREVIEW);

export const callCommissionAccrualExtend = httpsCallable<
  CommissionAccrualExtendInput,
  CommissionAccrualExtendResponse
>(functions, CALLABLES.COMMISSION_ACCRUAL_EXTEND);

export const callCommissionPayoutPreview = httpsCallable<
  CommissionPayoutPreviewInput,
  CommissionPayoutPreviewResponse
>(functions, CALLABLES.COMMISSION_PAYOUT_PREVIEW);

export const callCommissionSendAccrual = httpsCallable<
  CommissionSendAccrualInput,
  CommissionSendAccrualResponse
>(functions, CALLABLES.COMMISSION_SEND_ACCRUAL);

export const callCommissionSendAccrualTest = httpsCallable<
  CommissionSendAccrualInput,
  CommissionSendAccrualResponse
>(functions, CALLABLES.COMMISSION_SEND_ACCRUAL_TEST);

export const callCommissionAccrualSendUrl = httpsCallable<
  CommissionAccrualSendUrlInput,
  CommissionAccrualSendUrlResponse
>(functions, CALLABLES.COMMISSION_ACCRUAL_SEND_URL);

// ── Agents layer ──
import type {
  CommissionAgentMonthInput,
  CommissionAgentUploadInput,
  CommissionAgentUploadResponse,
  CommissionAgentPullResponse,
  CommissionAgentComputeResponse,
  CommissionAgentGetReportResponse,
  CommissionAgentSaveAdjustmentInput,
  CommissionAgentAdjustReissueInput,
  CommissionAgentSavePaidInput,
  CommissionAgentSaveResponse,
  CommissionAgentMyStatementResponse,
  CommissionAgentYtdResponse,
  CommissionAgentManagerRowsResponse,
  CommissionAgentStatementPdfInput,
  CommissionAgentStatementPdfResponse,
  CommissionAgentReleaseInput,
  CommissionAgentReleaseResponse,
  CommissionAgentLockPayoutInput,
  CommissionAgentLockPayoutResponse,
  CommissionAgentYearInput,
  CommissionAgentPayoutYearResponse,
  CommissionAgentSetDeltaInput,
  CommissionAgentSetDeltaResponse,
} from '@daaily/shared';

export const callCommissionAgentUploadSource = httpsCallable<CommissionAgentUploadInput, CommissionAgentUploadResponse>(functions, CALLABLES.COMMISSION_AGENT_UPLOAD_SOURCE);
export const callCommissionAgentPull = httpsCallable<CommissionAgentMonthInput, CommissionAgentPullResponse>(functions, CALLABLES.COMMISSION_AGENT_PULL);
export const callCommissionAgentComputeReport = httpsCallable<CommissionAgentMonthInput, CommissionAgentComputeResponse>(functions, CALLABLES.COMMISSION_AGENT_COMPUTE_REPORT);
export const callCommissionAgentGetReport = httpsCallable<CommissionAgentMonthInput, CommissionAgentGetReportResponse>(functions, CALLABLES.COMMISSION_AGENT_GET_REPORT);
export const callCommissionAgentSaveAdjustment = httpsCallable<CommissionAgentSaveAdjustmentInput, CommissionAgentSaveResponse>(functions, CALLABLES.COMMISSION_AGENT_SAVE_ADJUSTMENT);
export const callCommissionAgentSavePaid = httpsCallable<CommissionAgentSavePaidInput, CommissionAgentSaveResponse>(functions, CALLABLES.COMMISSION_AGENT_SAVE_PAID);
// Correction on a locked/released month: recompute + re-lock + re-issue PDF + email — can exceed the client default.
export const callCommissionAgentAdjustReissue = httpsCallable<CommissionAgentAdjustReissueInput, { ok: true; totalCommission: number; currency: string }>(functions, CALLABLES.COMMISSION_AGENT_ADJUST_REISSUE, { timeout: 540000 });
// Two-stage correction: apply (recompute + flag pending, nothing issued) → review → issue.
export const callCommissionAgentCorrectionApply = httpsCallable<CommissionAgentAdjustReissueInput, { ok: true; totalCommission: number; currency: string }>(functions, CALLABLES.COMMISSION_AGENT_CORRECTION_APPLY, { timeout: 540000 });
export const callCommissionAgentCorrectionIssue = httpsCallable<{ monthId: string; agentKey: string }, { ok: true; totalCommission: number; currency: string }>(functions, CALLABLES.COMMISSION_AGENT_CORRECTION_ISSUE, { timeout: 540000 });
// Payout summary TEST send (PDF+XLSX to one address).
export const callCommissionAgentPayoutSummaryTest = httpsCallable<{ year: number; to: string }, { ok: true; agents: number; throughLabel: string }>(functions, CALLABLES.COMMISSION_AGENT_PAYOUT_SUMMARY_TEST, { timeout: 300000 });
export const callCommissionAgentMyStatement = httpsCallable<CommissionAgentMonthInput, CommissionAgentMyStatementResponse>(functions, CALLABLES.COMMISSION_AGENT_MY_STATEMENT);
export const callCommissionAgentMyYtd = httpsCallable<{ year: number }, CommissionAgentYtdResponse>(functions, CALLABLES.COMMISSION_AGENT_MY_YTD);
export const callCommissionAgentManagerRows = httpsCallable<CommissionAgentMonthInput, CommissionAgentManagerRowsResponse>(functions, CALLABLES.COMMISSION_AGENT_MANAGER_ROWS);
export const callCommissionAgentStatementPdf = httpsCallable<CommissionAgentStatementPdfInput, CommissionAgentStatementPdfResponse>(functions, CALLABLES.COMMISSION_AGENT_STATEMENT_PDF);
// Release builds a PDF + vault + Drive per agent — can exceed the 70s client
// default for a full month. Wait up to the server's 9-min budget.
export const callCommissionAgentRelease = httpsCallable<CommissionAgentReleaseInput, CommissionAgentReleaseResponse>(functions, CALLABLES.COMMISSION_AGENT_RELEASE, { timeout: 540000 });
export const callCommissionAgentLockPayout = httpsCallable<CommissionAgentLockPayoutInput, CommissionAgentLockPayoutResponse>(functions, CALLABLES.COMMISSION_AGENT_LOCK_PAYOUT);
export const callCommissionAgentPayoutYear = httpsCallable<CommissionAgentYearInput, CommissionAgentPayoutYearResponse>(functions, CALLABLES.COMMISSION_AGENT_PAYOUT_YEAR);
export const callCommissionAgentSetDelta = httpsCallable<CommissionAgentSetDeltaInput, CommissionAgentSetDeltaResponse>(functions, CALLABLES.COMMISSION_AGENT_SET_DELTA);

// ── Other layer (person-specific bonus plans, quarterly) ──
import type {
  CommissionOtherQuarterInput,
  CommissionOtherSaveAdjustmentInput,
  CommissionOtherReleaseInput,
  CommissionOtherYearInput,
  CommissionOtherComputeResponse,
  CommissionOtherGetReportResponse,
  CommissionOtherReleaseResponse,
  CommissionOtherMyStatementsResponse,
} from '@daaily/shared';
export const callCommissionOtherComputeReport = httpsCallable<CommissionOtherQuarterInput, CommissionOtherComputeResponse>(functions, CALLABLES.COMMISSION_OTHER_COMPUTE_REPORT, { timeout: 120000 });
export const callCommissionOtherGetReport = httpsCallable<CommissionOtherQuarterInput, CommissionOtherGetReportResponse>(functions, CALLABLES.COMMISSION_OTHER_GET_REPORT);
export const callCommissionOtherSaveAdjustment = httpsCallable<CommissionOtherSaveAdjustmentInput, CommissionOtherComputeResponse>(functions, CALLABLES.COMMISSION_OTHER_SAVE_ADJUSTMENT, { timeout: 120000 });
export const callCommissionOtherStatementPdf = httpsCallable<CommissionOtherQuarterInput, CommissionAgentStatementPdfResponse>(functions, CALLABLES.COMMISSION_OTHER_STATEMENT_PDF, { timeout: 120000 });
export const callCommissionOtherRelease = httpsCallable<CommissionOtherReleaseInput, CommissionOtherReleaseResponse>(functions, CALLABLES.COMMISSION_OTHER_RELEASE, { timeout: 300000 });
export const callCommissionOtherMyStatements = httpsCallable<CommissionOtherYearInput, CommissionOtherMyStatementsResponse>(functions, CALLABLES.COMMISSION_OTHER_MY_STATEMENTS);
import type { CommissionMyAccessResponse } from '@daaily/shared';
export const callCommissionMyAccess = httpsCallable<Record<string, never>, CommissionMyAccessResponse>(functions, CALLABLES.COMMISSION_MY_ACCESS);
